/**
 * Stock Chart Viewer - DOM Elements
 */

export const elements = {
    // Search
    symbolInput: document.getElementById('symbol-input'),
    searchBtn: document.getElementById('search-btn'),
    // Mode Toggle
    modeToggleWrapper: document.getElementById('mode-toggle-wrapper'),
    modeOptions: document.querySelectorAll('.mode-option'),

    // Stock Info
    stockInfo: document.getElementById('stock-info'),
    companyName: document.getElementById('company-name'),
    tickerSymbol: document.getElementById('ticker-symbol'),
    currentPrice: document.getElementById('current-price'),
    priceChange: document.getElementById('price-change'),

    // Chart
    chartContainer: document.getElementById('chart'),
    welcomeMessage: document.getElementById('welcome-message'),

    // Stats
    statsPanel: document.getElementById('stats-panel'),
    statOpen: document.getElementById('stat-open'),
    statHigh: document.getElementById('stat-high'),
    statLow: document.getElementById('stat-low'),
    statVolume: document.getElementById('stat-volume'),

    // UI Controls
    loadingOverlay: document.getElementById('loading-overlay'),
    errorMessage: document.getElementById('error-message'),
    errorText: document.getElementById('error-text'),
    errorClose: document.getElementById('error-close'),
    periodBtns: document.querySelectorAll('.period-btn'),
    quickSymbols: document.querySelectorAll('.quick-symbol'),

    // Watchlist
    watchlistBtn: document.getElementById('watchlist-btn'),
    watchlistPanel: document.getElementById('watchlist-panel'),
    watchlistItems: document.getElementById('watchlist-items'),
    watchlistCount: document.getElementById('watchlist-count'),
    watchlistInput: document.getElementById('watchlist-input'),
    watchlistAddBtn: document.getElementById('watchlist-add-btn'),

    // Indicators
    sma20Btn: document.getElementById('sma20-btn'),
    sma50Btn: document.getElementById('sma50-btn'),
    bbBtn: document.getElementById('bb-btn'),
    rsiBtn: document.getElementById('rsi-btn'),
    rsiBtn: document.getElementById('rsi-btn'),
    macdBtn: document.getElementById('macd-btn'),
    ichimokuBtn: document.getElementById('ichimoku-btn'),
    stochBtn: document.getElementById('stoch-btn'),

    // Indicator Charts
    rsiChartContainer: document.getElementById('rsi-chart'),
    rsiChartContainer: document.getElementById('rsi-chart'),
    macdChartContainer: document.getElementById('macd-chart'),
    stochChartContainer: document.getElementById('stoch-chart'),

    // Trading
    buyBtn: document.getElementById('buy-btn'),
    sellBtn: document.getElementById('sell-btn'),
    tradeSharesInput: document.getElementById('trade-shares-input'),
    tradeSharesInput: document.getElementById('trade-shares-input'),
    walletBalance: document.getElementById('wallet-balance'),

    // Backtester
    testBtn: document.getElementById('test-btn'),
    // Multi-Chart
    multiChartBtn: document.getElementById('multi-chart-btn'),
    snapshotBtn: document.getElementById('snapshot-btn'),
    backtestPanel: document.getElementById('backtest-panel'),
    closeBacktestBtn: document.getElementById('close-backtest-btn'),
    strategySelect: document.getElementById('strategy-select'),
    runBacktestBtn: document.getElementById('run-backtest-btn'),
    backtestResults: document.getElementById('backtest-results'),
    btReturn: document.getElementById('bt-return'),
    btTrades: document.getElementById('bt-trades'),
    btEquity: document.getElementById('bt-equity'),

    btEquity: document.getElementById('bt-equity'),

    // News
    newsPanel: document.getElementById('news-feed-panel'),
    closeNewsBtn: document.getElementById('close-news-btn'),
    newsContainer: document.getElementById('news-container'),

    // Refresh & Cache
    refreshBtn: document.getElementById('refresh-btn'),
    cacheIndicator: document.getElementById('cache-indicator'),

    // Cache Panel
    cachePanel: document.getElementById('cache-panel'),
    cachePanelToggle: document.getElementById('cache-panel-toggle'),
    cachePanelBody: document.getElementById('cache-panel-body'),
    apiUsageFill: document.getElementById('api-usage-fill'),
    apiUsedCount: document.getElementById('api-used-count'),
    apiRemainingCount: document.getElementById('api-remaining-count'),
    apiResetTime: document.getElementById('api-reset-time'),
    cacheOnlyToggle: document.getElementById('cache-only-toggle'),
    storageModeSelect: document.getElementById('storage-mode-select'),
    cachedDataList: document.getElementById('cached-data-list'),
    clearAllCacheBtn: document.getElementById('clear-all-cache-btn'),

    // Navigation
    homeLink: document.getElementById('home-link'),

    // Header Status
    headerApiCount: document.getElementById('header-api-count'),
    headerCacheMode: document.getElementById('header-cache-mode'),

    // AI Assistant
    aiPanel: document.getElementById('ai-panel'),
    aiToggleBtn: document.getElementById('ai-toggle-btn'),
    aiCloseBtn: document.getElementById('ai-close-btn'),
    aiChatMessages: document.getElementById('ai-chat-messages'),
    aiChatInput: document.getElementById('ai-chat-input'),
    aiSendBtn: document.getElementById('ai-send-btn'),
    aiAnalyzeBtn: document.getElementById('ai-analyze-btn'),

    // Toolbar Elements
    chartTypeSelect: document.getElementById('chart-type-select'),
    paramsBtn: document.getElementById('params-btn'),
    drawLineBtn: document.getElementById('draw-line-btn'),
    clearDrawingsBtn: document.getElementById('clear-drawings-btn'),
    compareInput: document.getElementById('compare-input'),
    compareBtn: document.getElementById('compare-btn'),
    exportCsvBtn: document.getElementById('export-csv-btn'),

    // Dashboard
    marketStatus: document.getElementById('market-status'),
    newsSection: document.getElementById('news-section'),
    newsFeedContainer: document.getElementById('news-feed-container'),

    // Sidebar
    langToggleBtn: document.getElementById('lang-toggle-btn'),

    // Toast
    toastContainer: document.getElementById('toast-container'),
};
